import classNames from 'classnames/bind';
import React, { useCallback } from 'react';
import Checkbox from '../Checkbox';
import Divider from '../Divider';
import { CheckboxListProps } from './CheckboxList.types';
import styles from './CheckboxList.module.scss';

const cx = classNames.bind(styles);

const CheckboxList = ({
  dataTestId,
  options,
  checkedIds,
  onChange,
  maxHeight,
}: CheckboxListProps): React.ReactElement => {
  const isChecked = useCallback((id: string) => checkedIds.includes(id), [checkedIds]);
  const onCheck = (id: string, checked?: boolean) => {
    if (checked) {
      onChange?.([...checkedIds, id]);
    } else {
      onChange?.(checkedIds.filter((checkedId) => checkedId !== id));
    }
  };
  const onSelectAll = (checked?: boolean) => {
    if (checked) {
      onChange?.(options.map((option) => option.id));
    } else {
      onChange?.([]);
    }
  };

  const allSelected = options.length === checkedIds.length;
  const indeterminate = !allSelected && checkedIds.length > 0;

  return (
    <div className={cx('body')} data-testid={dataTestId} style={{ maxHeight: `${maxHeight}px` }}>
      <Checkbox
        className={cx('option', 'select-all')}
        dataTestId={`${dataTestId}-select-all`}
        label="Select All"
        checked={allSelected}
        indeterminate={indeterminate}
        onChange={(_, data) => onSelectAll(data.checked)}
      />
      <Divider />
      <div className={cx('options')}>
        {options.map((option) => (
          <Checkbox
            className={cx('option')}
            dataTestId={`${dataTestId}-${option.id}`}
            id={option.id}
            key={option.id}
            label={option.label}
            checked={isChecked(option.id)}
            onChange={(_, data) => onCheck(option.id, data.checked)}
          />
        ))}
      </div>
    </div>
  );
};

export default CheckboxList;
